


























import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class contextMenu extends Vue {
  @Prop({ type: String, default: null }) id!: string;
  @Prop({ type: Boolean, default: true }) showChange!: boolean;
  @Prop({ type: Boolean, default: true }) showDelet!: boolean;
  @Prop({ type: Boolean, default: false }) showRestore!: boolean;

  showContext = false;

  contextX = 0;
  contextY = 0;

  /** true: change, false: delete */
  changeElement(id: string, flag: boolean): void {
    this.$emit("changeElement", id, flag);
  }

  closeContext(): void {
    this.showContext = false;
  }

  mounted(): void {
    document.addEventListener("click", this.closeContext);
  }

  destroyed(): void {
    document.removeEventListener("click", this.closeContext);
  }
}
